import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Bars } from "react-loader-spinner";
import axiosInstance from "../../Shared/axiosInstance";

export default function InventoryValue() {
  const INVENTORY_VALUE_API = "/Product/inventory-value";

  const [inventoryData, setInventoryData] = useState(null);
  const [loading, setLoading] = useState(true);

  // جلب البيانات من الـ API
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(INVENTORY_VALUE_API);
      setInventoryData(response.data.data);
    } catch (err) {
      console.error("خطأ أثناء جلب البيانات:", err);
      Swal.fire("خطأ", "فشل في تحميل بيانات المخزون", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // عرض شاشة التحميل
  if (loading) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center flex-column">
        <Bars height="80" width="80" color="#2563eb" ariaLabel="loading" />
        <p className="mt-3" style={{ color: "#64748b", fontSize: "18px" }}>
          جاري تحميل قيمة المخزون...
        </p>
      </div>
    );
  }

  if (!inventoryData) return null;

  // استخراج البيانات
  const {
    totalPurchaseValue,
    totalSaleValue,
    potentialProfit,
    profitPercentage,
    totalProductCount,
    totalQuantity,
  } = inventoryData;

  return (
    <div className="container py-5" style={{ maxWidth: "1400px" }}>
      {/* الرأس */}
      <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
        <div>
          <h2
            style={{
              color: "#2563eb",
              fontWeight: "700",
              fontSize: "28px",
              marginBottom: "4px",
            }}
          >
            قيمة المخزون الحالي
          </h2>
          <small style={{ color: "#64748b", fontSize: "14px" }}>
            تقييم شامل لرأس المال المخزون والربح المتوقع
          </small>
        </div>

        {/* زر إعادة التحميل */}
        <button
          onClick={fetchData}
          disabled={loading}
          style={{
            background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            border: "none",
            fontSize: "15px",
            fontWeight: "600",
            cursor: loading ? "not-allowed" : "pointer",
            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
            transition: "all 0.3s ease",
            opacity: loading ? 0.6 : 1,
          }}
          onMouseOver={(e) =>
            !loading && (e.target.style.transform = "translateY(-2px)")
          }
          onMouseOut={(e) =>
            !loading && (e.target.style.transform = "translateY(0)")
          }
        >
          <i className="bi bi-arrow-clockwise me-2"></i>
          تحديث البيانات
        </button>
      </div>

      {/* بطاقة الربح المتوقع الكبيرة */}
      <div
        className="mb-4"
        style={{
          background:
            potentialProfit >= 0
              ? "linear-gradient(135deg, #16a34a 0%, #15803d 100%)"
              : "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
          border: "none",
          borderRadius: "16px",
          padding: "50px 30px",
          textAlign: "center",
          boxShadow: "0 12px 32px rgba(0, 0, 0, 0.2)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background Icon */}
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            fontSize: "250px",
            color: "rgba(255, 255, 255, 0.05)",
            transform: "rotate(-15deg)",
          }}
        >
          <i className="bi bi-graph-up-arrow"></i>
        </div>

        {/* Content */}
        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: "14px",
              fontWeight: "600",
              marginBottom: "12px",
              textTransform: "uppercase",
              letterSpacing: "2px",
            }}
          >
            الربح المتوقع
          </div>
          <div
            style={{
              color: "#fff",
              fontSize: "56px",
              fontWeight: "700",
              marginBottom: "12px",
            }}
          >
            {potentialProfit.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            ج.م
          </div>
          <div
            style={{
              color: "rgba(255, 255, 255, 0.7)",
              fontSize: "15px",
              marginBottom: "20px",
            }}
          >
            إذا تم بيع جميع المنتجات الموجودة في المخزون
          </div>
          <div
            style={{
              color: "rgba(255, 255, 255, 0.95)",
              fontSize: "18px",
              fontWeight: "600",
              background: "rgba(255, 255, 255, 0.15)",
              padding: "10px 20px",
              borderRadius: "8px",
              display: "inline-block",
            }}
          >
            <i className="bi bi-percent me-2"></i>
            نسبة الربح: {profitPercentage.toFixed(2)}%
          </div>
        </div>
      </div>

      {/* بطاقات القيم الرئيسية */}
      <div className="row g-4 mb-4">
        {/* إجمالي التكلفة */}
        <div className="col-md-6">
          <div
            style={{
              background: "#fff",
              border: "2px solid #fecaca",
              borderRadius: "12px",
              padding: "32px",
              textAlign: "center",
              boxShadow: "0 6px 20px rgba(220, 38, 38, 0.15)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Background Icon */}
            <div
              style={{
                position: "absolute",
                top: "-30px",
                left: "-30px",
                fontSize: "140px",
                color: "#fee2e208",
                transform: "rotate(15deg)",
              }}
            >
              <i className="bi bi-cart-check-fill"></i>
            </div>

            {/* Content */}
            <div style={{ position: "relative", zIndex: 1 }}>
              <div
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #dc2626, #b91c1c)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  boxShadow: "0 6px 16px rgba(220, 38, 38, 0.3)",
                }}
              >
                <i
                  className="bi bi-cart-check-fill"
                  style={{ fontSize: "36px", color: "#fff" }}
                ></i>
              </div>

              <h6
                style={{
                  color: "#64748b",
                  fontSize: "14px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  marginBottom: "12px",
                  letterSpacing: "1px",
                }}
              >
                إجمالي تكلفة الشراء
              </h6>
              <h3
                style={{
                  color: "#dc2626",
                  fontSize: "40px",
                  fontWeight: "700",
                  marginBottom: "8px",
                }}
              >
                {totalPurchaseValue.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                ج.م
              </h3>
              <small style={{ color: "#64748b", fontSize: "14px" }}>
                رأس المال المستثمر في المخزون
              </small>
            </div>
          </div>
        </div>

        {/* إجمالي قيمة البيع */}
        <div className="col-md-6">
          <div
            style={{
              background: "#fff",
              border: "2px solid #bbf7d0",
              borderRadius: "12px",
              padding: "32px",
              textAlign: "center",
              boxShadow: "0 6px 20px rgba(22, 163, 74, 0.15)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Background Icon */}
            <div
              style={{
                position: "absolute",
                top: "-30px",
                right: "-30px",
                fontSize: "140px",
                color: "#dcfce708",
                transform: "rotate(-15deg)",
              }}
            >
              <i className="bi bi-cash-stack"></i>
            </div>

            {/* Content */}
            <div style={{ position: "relative", zIndex: 1 }}>
              <div
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #16a34a, #15803d)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  boxShadow: "0 6px 16px rgba(22, 163, 74, 0.3)",
                }}
              >
                <i
                  className="bi bi-cash-stack"
                  style={{ fontSize: "36px", color: "#fff" }}
                ></i>
              </div>

              <h6
                style={{
                  color: "#64748b",
                  fontSize: "14px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  marginBottom: "12px",
                  letterSpacing: "1px",
                }}
              >
                إجمالي قيمة البيع المتوقعة
              </h6>
              <h3
                style={{
                  color: "#16a34a",
                  fontSize: "40px",
                  fontWeight: "700",
                  marginBottom: "8px",
                }}
              >
                {totalSaleValue.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                ج.م
              </h3>
              <small style={{ color: "#64748b", fontSize: "14px" }}>
                الإيرادات المتوقعة من بيع كامل المخزون
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* بطاقات الإحصائيات */}
      <div className="row g-4">
        {/* عدد المنتجات */}
        <div className="col-md-6">
          <div
            style={{
              background: "#fff",
              border: "2px solid #dbeafe",
              borderRadius: "12px",
              padding: "28px",
              boxShadow: "0 4px 16px rgba(37, 99, 235, 0.1)",
              display: "flex",
              alignItems: "center",
              gap: "24px",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 6px 16px rgba(37, 99, 235, 0.25)",
              }}
            >
              <i
                className="bi bi-box-seam-fill"
                style={{ fontSize: "40px", color: "#fff" }}
              ></i>
            </div>

            <div style={{ flex: 1 }}>
              <h6
                style={{
                  color: "#64748b",
                  fontSize: "13px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  marginBottom: "8px",
                  letterSpacing: "0.5px",
                }}
              >
                عدد المنتجات المختلفة
              </h6>
              <h3
                style={{
                  color: "#2563eb",
                  fontSize: "36px",
                  fontWeight: "700",
                  marginBottom: "4px",
                }}
              >
                {totalProductCount}
              </h3>
              <small style={{ color: "#64748b", fontSize: "13px" }}>
                منتج متوفر في المخزون
              </small>
            </div>
          </div>
        </div>

        {/* إجمالي الكمية */}
        <div className="col-md-6">
          <div
            style={{
              background: "#fff",
              border: "2px solid #fef3c7",
              borderRadius: "12px",
              padding: "28px",
              boxShadow: "0 4px 16px rgba(245, 158, 11, 0.1)",
              display: "flex",
              alignItems: "center",
              gap: "24px",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #f59e0b, #d97706)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 6px 16px rgba(245, 158, 11, 0.25)",
              }}
            >
              <i
                className="bi bi-stack"
                style={{ fontSize: "40px", color: "#fff" }}
              ></i>
            </div>

            <div style={{ flex: 1 }}>
              <h6
                style={{
                  color: "#64748b",
                  fontSize: "13px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  marginBottom: "8px",
                  letterSpacing: "0.5px",
                }}
              >
                إجمالي الكمية
              </h6>
              <h3
                style={{
                  color: "#f59e0b",
                  fontSize: "36px",
                  fontWeight: "700",
                  marginBottom: "4px",
                }}
              >
                {totalQuantity}
              </h3>
              <small style={{ color: "#64748b", fontSize: "13px" }}>
                قطعة إجمالي المخزون
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* معلومة إضافية */}
      <div
        className="mt-4"
        style={{
          background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
          border: "1px solid #93c5fd",
          borderRadius: "8px",
          padding: "20px",
          color: "#1e40af",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        <i className="bi bi-info-circle-fill me-2"></i>
        <strong>ملاحظة:</strong> هذه الأرقام تعكس القيمة الحالية للمنتجات
        الموجودة في المخزون فقط (الكمية {">"} 0). الربح المتوقع يحسب بافتراض
        بيع جميع المنتجات بأسعار البيع الحالية.
      </div>
    </div>
  );
}